
import { ConnectionListResult, PaginatedQueryWrapper } from '@tableau/data-catalog-shared';
import { SiteUrls } from '@tableau/shared-urls';
import * as React from 'react';
import { Messages } from '../../../gen-src/Localize';
import {
  ColumnFlowsQuery,
  ColumnFlowsQuery_columns_referencedByFlowColumnInputFieldConnection_nodes,
  ColumnFlowsQueryVariables,
} from '../../../gen-src/queries/ColumnFlowsQuery';
import { ColumnFlowsQueryGql } from '../../queries/ColumnFlowsQueryGql';
import { LinksDisplayGrid, LinksDisplayGridRowData } from '../sharedDisplayGrid/LinksDisplayGrid';

interface ColumnFlowsGridRowData extends LinksDisplayGridRowData {
  readonly flowId: string;
  readonly flowName: string;
}

type QueryVariables = ColumnFlowsQueryVariables;
type QueryResults = ColumnFlowsQuery;
type QueryResultListNode = ColumnFlowsQuery_columns_referencedByFlowColumnInputFieldConnection_nodes;
type GridRowData = ColumnFlowsGridRowData;

function selectConnectionListResult(resultData: ColumnFlowsQuery): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.columns && resultData.columns[0] && resultData.columns[0].referencedByFlowColumnInputFieldConnection;
}

function mapResultNode(node: QueryResultListNode): GridRowData {
  return {
    id: node.id,
    name: node.name,
    flowId: node.flow && node.flow.vizportalUrlId || '',
    flowName: node.flow && node.flow.name || ''
  };
}

function urlForLink(urls: SiteUrls, rowData: ColumnFlowsGridRowData) {
  return urls.flowLineageFieldPath(rowData.flowId, rowData.id);
}

function nameForLink(rowData: ColumnFlowsGridRowData): string | null {
  if (rowData.name === null) {
    return null;
  }

  return Messages.LinkNameWithParent({ name: rowData.name, parentName: rowData.flowName });
}

export type ColumnFlowsQueryGridProps = {
  readonly columnId: string;
  readonly rowCount: number | null;
};

export function ColumnFlowsQueryGrid(props: ColumnFlowsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyColumnUsedByFlowsGridMessage();
  return (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={ColumnFlowsQueryGql}
      partialQueryVariables={{ columnId: props.columnId }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={mapResultNode}
    >
      {({ rowStore }) =>
        <LinksDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          link={urlForLink}
          name={nameForLink}
        />
      }
    </PaginatedQueryWrapper>
  );
}
